import { FC } from 'react';

import { Option } from '@beeline/design-system-react/extracted-styles';

import { findEmployees } from 'src/api/bookings';
import { EmployeeShortInfo } from 'src/api/types';

import {
  AsyncAutocomplete,
  AsyncAutocompleteProps,
} from '../AsyncAutocomplete/AsyncAutocomplete';

const renderValue = (option: Option<string>): string => option.value ?? '';

export const toPersonOption = (
  employee: EmployeeShortInfo | null,
): Option<string> | null =>
  employee
    ? {
        id: employee.employeeNumber,
        value: `${employee.lastName ?? 'Фамилия'} ${employee.firstName ?? 'Имя'} ${employee.middleName ?? ''}`,
      }
    : null;

export const toEmployeeShortInfo = (
  option: Option<string> | null,
): EmployeeShortInfo | null => {
  if (!option) return null;

  const [lastName, firstName, middleName] = option.value.split(' ');
  return {
    employeeNumber: option.id as string,
    lastName,
    firstName,
    middleName,
  };
};

const fetchOptions = async (
  search: string,
  limit: number,
  offset: number,
): Promise<Option<string>[]> => {
  const employees = await findEmployees({
    searchText: search,
    itemLimit: limit,
    itemOffset: offset,
  });
  const result: Option<string>[] = [];
  for (const employee of employees) {
    const option = toPersonOption(employee);
    if (option) result.push(option);
  }
  return result;
};

export type PersonAutocompleteProps = Omit<
  AsyncAutocompleteProps<string>,
  'size' | 'noOptionsText' | 'renderValue' | 'fetchOptions' | 'fullWidth'
>;

export const PersonAutocomplete: FC<PersonAutocompleteProps> = props => {
  return (
    <AsyncAutocomplete
      {...props}
      size='medium'
      minSearch
      fullWidth
      noOptionsText='Сотрудники не найдены'
      renderValue={renderValue}
      fetchOptions={fetchOptions}
      showTooltip
    />
  );
};
